const configProviderContextKey = /* @__PURE__ */ Symbol();

export { configProviderContextKey };
//# sourceMappingURL=constants.mjs.map
